import React from 'react'
import { Link } from 'react-router-dom'

export default function LogisticsFast() {
    return (
        <>
            <section className="logistic-fast">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="support-box without">
                                <span>Ordering Equipment On Your Own</span>
                                <ul>
                                    <li><img src="/assets/images/cross-icon.webp" alt="Icon" /> Guess the equipment model from a catalogue and place the order.</li>
                                    <li><img src="/assets/images/cross-icon.webp" alt="Icon" />Equipment shows up but doesn't fit your machine or setup.</li>
                                    <li><img src="/assets/images/cross-icon.webp" alt="Icon" />  File a return request and wait days for it to process.</li>
                                    <li><img src="/assets/images/cross-icon.webp" alt="Icon" /> Bear the shipping cost for sending it back yourself.</li>
                                    <li><img src="/assets/images/cross-icon.webp" alt="Icon" /> Start over from scratch while your facility loses output.</li>
                                </ul>
                            </div>

                            <div className="support-box with">
                                <span>Ordering Equipment Through Supershine</span>
                                <ul>
                                    <li><img src="/assets/images/check-icon.webp" alt="Icon" /> Share your machine details and the issue you're facing.</li>
                                    <li><img src="/assets/images/check-icon.webp" alt="Icon" /> Our team matches you to the right compatible equipment.</li>
                                    <li><img src="/assets/images/check-icon.webp" alt="Icon" /> Availability is confirmed before you commit to the order.</li>
                                    <li><img src="/assets/images/check-icon.webp" alt="Icon" /> Equipment ships fast with zero compatibility surprises.</li>
                                    <li><img src="/assets/images/check-icon.webp" alt="Icon" /> No returns, no repeat orders, no wasted downtime.</li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="logistic-fastdetail">
                                <small className='gradient-color'>What Mismatched Equipment Really Costs You</small>
                                <h2 className='heading'>Saving On Equipment Today Can Break Your Machine Tomorrow</h2>
                                <p>Industrial laundry equipment operates under precise specs. A piece of equipment that looks like a fit but differs in capacity, voltage, or build rating can escalate a minor fault into a major breakdown. Supershine's team cross-checks every specification against your machine before dispatching, so you're not spending twice to solve a problem that should have been fixed the first time.</p>
                                <Link to={"/contact"} className="default-btn"> <span>Call Our Experts</span>  </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
